import { FC } from 'react'
import { useTranslation } from 'react-i18next';
// Redux
import { useAppSelector } from 'hooks/useStore';
import { selectQuestion, selectQuiz } from 'store/quiz/quizSelectors';
import { selectQuestionReady } from 'store/player/playerSelectors';
import QuestionTypes from 'types/QuestionTypes';
import IQuestion from 'models/Question';
import IQuiz from 'models/Quiz';

const Question:FC = () => {
  const { t } = useTranslation();

  const quiz:IQuiz = useAppSelector(selectQuiz);
  const question:IQuestion = useAppSelector(selectQuestion);
  const questionReady:boolean = useAppSelector(selectQuestionReady);

  if ( !questionReady && !question.video && !question.audio ) return null;
  return (
    <div
      className="my-2 p-1 mx-4 shadow-primary-border rounded-xl"
      style={{ backgroundColor: quiz.theme.contentBackgroundColor }}
    >
      <p className="text-base text-primary font-bold text-center">
        {question.title}
        {question.type === QuestionTypes.MultiChoice ? (
          <span className="block text-xs text-primary">
            {`( ${t('pages.question.multiChoiceHint')} )`}
          </span>
        ) : null}
      </p>
    </div>
  )
}

export default Question;
